// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-container--1LFAfSR0pHHmUtuhx4ifXN{width:210px !important}.select-detailLabel--ExA9es5m2wqc6gSqCPT3h{font-size:11px;color:#bbb}", "",{"version":3,"sources":["webpack://src/components/common/Select/select.module.scss"],"names":[],"mappings":"AAAA,0CACC,sBAAA,CAGD,2CACC,cAAA,CACA,UAAA","sourcesContent":[".container {\r\n\twidth: 210px !important;\r\n}\r\n\r\n.detailLabel {\r\n\tfont-size: 11px;\r\n\tcolor: #bbb;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "select-container--1LFAfSR0pHHmUtuhx4ifXN",
	"detailLabel": "select-detailLabel--ExA9es5m2wqc6gSqCPT3h"
};
export default ___CSS_LOADER_EXPORT___;
